import { Redirect } from 'expo-router';

import { MoneyMapSimulatorPage } from '../../../dev/money-map-simulator/MoneyMapSimulatorPage';

export default function MoneyMapSimulatorRoute() {
    // Use process.env directly (not IS_PRODUCTION) so the bundler can
    // dead-code-eliminate this component from production builds.
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    return <MoneyMapSimulatorPage />;
}
